/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
// import {KTIcon} from '../../../../helpers'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { PermissionGuard } from 'src/app/helpers/permissions'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {pathname} = useLocation()

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='home-3'
        title={intl.formatMessage({ id: 'MENU.HOME' })}
      />
         <SidebarMenuItem
        to='/my-tasks/my-tasks-listing'
        icon='questionnaire-tablet'
        title={intl.formatMessage({ id: 'MENU.MY_TASKS' })}
      />
      <SidebarMenuItem
        to='/library'
        icon='lots-shopping'
        title={intl.formatMessage({ id: 'MENU.LIBRARY' })}
      />
      {/* <SidebarMenuItemWithSub
        to='/my-tray'
        icon='directbox-default'
        title={intl.formatMessage({ id: 'MENU.MY_TRAY' })}
      >
        <SidebarMenuItem
          to='/my-tray/inbox'
          title={intl.formatMessage({ id: 'MENU.MY_TRAY.INBOX' })}
          hasBullet={true}
        />
        <SidebarMenuItem
          to='my-tray/outbox'
          title={intl.formatMessage({ id: 'MENU.MY_TRAY.OUTBOX' })}
          hasBullet={true}
        />
        <SidebarMenuItem
          to='my-tray/bookmark'
          title={intl.formatMessage({ id: 'MENU.MY_TRAY.BOOKMARK' })}
          hasBullet={true}
        />
      </SidebarMenuItemWithSub> */}

   

      <SidebarMenuItem
        to='/process/process-access'
        icon='share'
        title={intl.formatMessage({ id: 'MENU.PROCESS' })}
      />
      {/* <SidebarMenuItem to='/process/process-a' title='Process A' hasBullet={true} />
        <SidebarMenuItem to='/process/process-b' title='Process B' hasBullet={true} />
      </SidebarMenuItemWithSub> */}

      {/* <SidebarMenuItem
        to='/management'
        icon='gear'
        title={intl.formatMessage({ id: 'MENU.MANAGEMENT' })}
      />
      <SidebarMenuItem
        to='/inquiry'
        icon='question'
        title={intl.formatMessage({ id: 'MENU.INQUIRY' })}
      />
      <SidebarMenuItem
        to='/calendar'
        icon='calendar'
        title={intl.formatMessage({ id: 'MENU.DESIGN.CALENDAR' })}
      /> */}

      <div className='separator my-3' />

      <SidebarMenuItemWithSub
        to='/design'
        icon='design'
        title={intl.formatMessage({ id: 'MENU.DESIGN' })}
      >
        <SidebarMenuItemWithSub
          to='/design/lib-profile'
          icon='category'
          title={intl.formatMessage({ id: 'MENU.DESIGN.LIBRARY_PROFILE' })}
        >
          <PermissionGuard permission='REC_PROFILE_DESIGN_VIEW'>
            <SidebarMenuItem
              to='/design/lib-profile/record-profile-design'
              icon='tablet-text-down'
              title={intl.formatMessage({ id: 'MENU.DESIGN.LIBRARY_PROFILE.RECORD_PROFILE_DESIGN' })}
            />
          </PermissionGuard>
          <PermissionGuard permission='SEL_FIELD_VIEW'>
            <SidebarMenuItem
              to='/design/lib-profile/fields-lookup'
              icon='element-2'
              title={intl.formatMessage({ id: 'MENU.DESIGN.LIBRARY_PROFILE.FIELDS_LOOKUP' })}
            />
          </PermissionGuard>
          <PermissionGuard permission='DOC_TYPE_VIEW'>
            <SidebarMenuItem
              to='/design/lib-profile/document-type'
              icon='element-9'
              title={intl.formatMessage({ id: 'MENU.DESIGN.LIBRARY_PROFILE.DOCUMENT' })}
            />
          </PermissionGuard>
          <PermissionGuard permission='LIBRARY_ACCESS_VIEW'>
            <SidebarMenuItem
              to='/design/lib-profile/library-access-setting'
              icon='setting-2'
              title={intl.formatMessage({ id: 'MENU.DESIGN.LIBRARY_PROFILE.LIBRARY_ACCESS_SETTING' })}
            />
          </PermissionGuard>
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub
          to='/design/process'
          icon='share'
          title={intl.formatMessage({ id: 'MENU.DESIGN.PROCESS' })}
        >
          <PermissionGuard permission='PROCESS_DESIGN_VIEW'>
            <SidebarMenuItem
              to='/design/process/process-list'
              icon='questionnaire-tablet'
              title={intl.formatMessage({ id: 'MENU.DESIGN.PROCESS.PROCESS_LIST' })}
            />
          </PermissionGuard>
          <PermissionGuard permission='PROCESS_ACCESS_VIEW'>
            <SidebarMenuItem
              to='/process/process-access/process-access-permission'
              icon='setting-2'
              title={intl.formatMessage({ id: 'MENU.DESIGN.PROCESS.PROCESS_ACCESS' })}
            />
          </PermissionGuard>
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub>

      <div className='separator my-3' />

      <SidebarMenuItemWithSub
        to='/administration'
        icon='user-square'
        title={intl.formatMessage({ id: 'MENU.ADMINISTRATION' })}
      >
        <PermissionGuard permission='DEPT_VIEW'>
          <SidebarMenuItem
            to='/administration/department'
            icon='data'
            title={intl.formatMessage({ id: 'MENU.ADMINISTRATION.DEPARTMENT' })}
          />
        </PermissionGuard>
        <PermissionGuard permission='POSITION_VIEW'>
          <SidebarMenuItem
            to='/administration/position'
            icon='compass'
            title={intl.formatMessage({ id: 'MENU.ADMINISTRATION.POSITION' })}
          />
        </PermissionGuard>
        <PermissionGuard permission='USERS_VIEW'>
          <SidebarMenuItem
            to='/administration/user'
            icon='profile-user'
            title={intl.formatMessage({ id: 'MENU.ADMINISTRATION.USER' })}
          />
        </PermissionGuard>
        <PermissionGuard permission='MOD_ACCESS_VIEW'>
          <SidebarMenuItem
            to='/administration/access'
            icon='data'
            title={intl.formatMessage({ id: 'MENU.ADMINISTRATION.ACCESS' })}
          />
        </PermissionGuard>
        <PermissionGuard permission='AUDIT_VIEW'>
          <SidebarMenuItem
            to='/administration/audit'
            icon='book-open'
            title={intl.formatMessage({ id: 'MENU.ADMINISTRATION.AUDIT' })}
          />
        </PermissionGuard>
      </SidebarMenuItemWithSub>
    </>
  )
}

export { SidebarMenuMain }
